import {
  AbstractControl,
  FormControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { regexes } from './regular-expressions';

export function hasLength(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const forbidden = !regexes.PASSWORDPATTERNLENGTH.test(control.value);
    return forbidden ? { nolength: false } : null;
  };
}

export function hasUpperCase(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const forbidden = !regexes.PASSWORDPATTERNUPPERCASE.test(control.value);
    return forbidden ? { nouppercase: false } : null;
  };
}

export function hasLowerCase(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const forbidden = !regexes.PASSWORDPATTERLOWERCASE.test(control.value);
    return forbidden ? { nolowercase: false } : null;
  };
}

export function hasNumbers(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const forbidden = !regexes.PASSWORDPATTERNDIGIT.test(control.value);
    return forbidden ? { nonumbers: false } : null;
  };
}

// export function hasSpecChars(): ValidatorFn {
//   return (control: AbstractControl): ValidationErrors | null => {
//     const forbidden = !regexes.PASSWORDPATTERNSPECCHAR.test(control.value);
//     return forbidden ? { nospecs: false } : null;
//   };
// }

export const validations = (password: FormControl) => {
  return {
    length: {
      valid: regexes.PASSWORDPATTERNLENGTH.test(password.value),
      //&& this.password.dirty
      //&& regexes.PASSWORDPATTERNLENGTH.test(this.passwordConfirm.value),
      //&& this.passwordConfirm.dirty
      invalid:
        !regexes.PASSWORDPATTERNLENGTH.test(password.value) && password.dirty, // ||
      // (!regexes.PASSWORDPATTERNLENGTH.test(this.passwordConfirm.value) &&
      //   this.passwordConfirm.dirty),
    },
    uppercase: {
      valid: regexes.PASSWORDPATTERNUPPERCASE.test(password.value),
      //&& this.password.dirty
      //regexes.PASSWORDPATTERNUPPERCASE.test(this.passwordConfirm.value),
      //&& this.passwordConfirm.dirty
      invalid:
        !regexes.PASSWORDPATTERNUPPERCASE.test(password.value) &&
        password.dirty, // ||
      // (!regexes.PASSWORDPATTERNUPPERCASE.test(this.passwordConfirm.value) &&
      //   this.passwordConfirm.dirty),
    },
    lowercase: {
      valid: regexes.PASSWORDPATTERLOWERCASE.test(password.value),
      //&& this.password.dirty
      //regexes.PASSWORDPATTERNUPPERCASE.test(this.passwordConfirm.value),
      //&& this.passwordConfirm.dirty
      invalid:
        !regexes.PASSWORDPATTERLOWERCASE.test(password.value) && password.dirty, // ||
      // (!regexes.PASSWORDPATTERNUPPERCASE.test(this.passwordConfirm.value) &&
      //   this.passwordConfirm.dirty),
    },
    // specchar: {
    //   valid: regexes.PASSWORDPATTERNSPECCHAR.test(password.value),
    //   //&& this.password.dirty
    //   // regexes.PASSWORDPATTERNSPECCHAR.test(this.passwordConfirm.value),
    //   //&& this.passwordConfirm.dirty
    //   invalid:
    //     !regexes.PASSWORDPATTERNSPECCHAR.test(password.value) && password.dirty, // ||
    //   // (!regexes.PASSWORDPATTERNSPECCHAR.test(this.passwordConfirm.value) &&
    //   //   this.passwordConfirm.dirty),
    // },
    digit: {
      valid: regexes.PASSWORDPATTERNDIGIT.test(password.value),
      //&& this.password.dirty
      //regexes.PASSWORDPATTERNDIGIT.test(this.passwordConfirm.value),
      //&& this.passwordConfirm.dirty
      invalid:
        !regexes.PASSWORDPATTERNDIGIT.test(password.value) && password.dirty, // ||
      // (!regexes.PASSWORDPATTERNDIGIT.test(this.passwordConfirm.value) &&
      //   this.passwordConfirm.dirty),
    },
  };
};
